export default {
  cashback: {
    enabled: 'Punkte erfolgreich angewendet',
  },
};
